import type { ServiceAgreementStatus } from "@/contracts";

import type { Tone } from "@/components/ui/badge";
import i18n from "@/i18n";

export const SERVICE_STATUS_LABELS: Record<ServiceAgreementStatus, string> = {
  get DRAFT() {
    return i18n.t("services:status.DRAFT");
  },
  get ISSUED() {
    return i18n.t("services:status.ISSUED");
  },
  get SIGNED() {
    return i18n.t("services:status.SIGNED");
  },
  get CLOSED() {
    return i18n.t("services:status.CLOSED");
  },
  get CANCELLED() {
    return i18n.t("services:status.CANCELLED");
  },
};

export const SERVICE_STATUS_TONES: Record<ServiceAgreementStatus, Tone> = {
  DRAFT: "neutral",
  ISSUED: "info",
  SIGNED: "ok",
  CLOSED: "neutral",
  CANCELLED: "neutral",
};
